import { TransactionSource } from '../api/CalculationApi';
import { CreditNoteType } from '../config/Constants';
import { PostingType } from '../data/models/Posting';
import {
  BankTransactionType,
  ReconciliationType,
} from '../data/models/ReconciliationLog';

const baseUrl = (shortcode: string) => {
  return `https://go.xero.com/organisationlogin/default.aspx?shortcode=${shortcode}`;
};

export const xeroDeepLink = (
  shortcode: string,
  type: TransactionSource,
  externalId: string
): string => {
  let url = baseUrl(shortcode);

  switch (type) {
    case TransactionSource.ACCREC:
      url += `&redirecturl=/AccountsReceivable/View.aspx%3FInvoiceID=${externalId}`;
      break;
    case TransactionSource.ARPREPAYMENT:
    case TransactionSource.AROVERPAYMENT:
    case TransactionSource.ACCRECCREDIT:
      url += `&redirecturl=/AccountsReceivable/ViewCreditNote.aspx%3FCreditNoteID=${externalId}`;
      break;
    case TransactionSource.APPREPAYMENT:
    case TransactionSource.APOVERPAYMENT:
    case TransactionSource.ACCPAYCREDIT:
      url += `&redirecturl=/AccountsPayable/ViewCreditNote.aspx%3FCreditNoteID=${externalId}`;
      break;
    case TransactionSource.ACCPAY:
      url += `&redirecturl=/AccountsPayable/View.aspx%3FInvoiceID=${externalId}`;
      break;
    case TransactionSource.ARCREDITPAYMENT:
    case TransactionSource.APCREDITPAYMENT:
      url += `&redirecturl=/Bank/ViewTransaction.aspx%3FbankTransactionID=${externalId}`;
      break;

    case TransactionSource.ACCRECPAYMENT:
    case TransactionSource.ACCPAYPAYMENT:
    case TransactionSource.CASHREC:
    case TransactionSource.CASHPAID:
      url += `&redirecturl=/Bank/ViewTransaction.aspx%3FbankTransactionID=${externalId}`;
      break;

    case TransactionSource.MANJOURNAL:
      url += `&redirecturl=/Journal/View.aspx?invoiceID=${externalId}`;
      break;

    case TransactionSource.SOURCE_LESS:
      url += `&redirecturl=/GeneralLedger/JournalDetails.aspx%3FjournalID=${externalId}`;
      break;
    case TransactionSource.TRANSFER:
    case TransactionSource.EXPCLAIM:
    case TransactionSource.EXPPAYMENT:
    case TransactionSource.PAYSLIP:
    case TransactionSource.WAGEPAYABLE:
    case TransactionSource.INTEGRATEDPAYROLLPE:
    case TransactionSource.INTEGRATEDPAYROLLPT:
    case TransactionSource.EXTERNALSPENDMONEY:
    case TransactionSource.INTEGRATEDPAYROLLPTPAYMENT:
    case TransactionSource.INTEGRATEDPAYROLLCN:
    default:
      return null;
  }

  return url;
};

export const xeroBankTransactionUrl = (
  shortcode: string,
  accountId: string,
  externalId: string
): string => {
  return `${baseUrl(shortcode)}&redirecturl=/Bank/TransactionDetails.aspx%3FaccountID=${accountId}%26statementLineID=${externalId}`;
};

export const bragXeroDeepLink = (
  shortcode: string,
  bankTxType: BankTransactionType,
  reconciliationType: ReconciliationType,
  postingType: PostingType,
  creditNoteType: CreditNoteType,
  externalId: string
): string => {
  const txType = (() => {
    if (
      reconciliationType === ReconciliationType.INVOICE ||
      postingType === PostingType.INVOICE
    ) {
      return bankTxType === BankTransactionType.PAYMENT
        ? TransactionSource.ACCPAY
        : TransactionSource.ACCREC;
    }

    if (
      (creditNoteType === CreditNoteType.OVERPAYMENT &&
        bankTxType === BankTransactionType.PAYMENT) ||
      (creditNoteType === CreditNoteType.REFUND &&
        bankTxType === BankTransactionType.RECEIVED)
    ) {
      return TransactionSource.ACCPAYCREDIT;
    } else {
      return TransactionSource.ACCRECCREDIT;
    }
  })();

  return xeroDeepLink(shortcode, txType, externalId);
};
